import React from 'react';

export default function FixedButton({}) {
  return (
    <div className="flex-center">
      <a href="" className="blue_btn_fix prt-bold fs-18 fc-white" onClick="">
        매장 효율을 높여주는 크림봇 상담받기
      </a>
    </div>
  );
}
